import { render, staticRenderFns } from "./FichasMMA.vue?vue&type=template&id=2499bcce&"
import script from "./FichasMMA.vue?vue&type=script&lang=js&"
export * from "./FichasMMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports